import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/unlink.svg";
var UnlinkOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  UnlinkOutline_default as default
};
